/* GENERATED by scripts/experience/generate-design-tokens.ts. DO NOT EDIT. */
export const EXPERIENCE_ARTIFACT_TOKENS = {
  schemaVersion: '1.0.0-candidate.1',
  adapterVersion: '1.0.0-candidate.1',
  colours: {
    'identity.statura.decorative': '#96A998',
    'identity.statura.foreground': '#3E5D4A',
    'identity.tenant.fallback': '#3E5D4A',
    'surface.canvas': '#F8FAFC',
    'surface.base': '#FFFFFF',
    'surface.subtle': '#F5F6F2',
    'surface.inverse': '#0F172A',
    'text.primary': '#1E293B',
    'text.secondary': '#475569',
    'text.body': '#334155',
    'text.muted': '#64748B',
    'text.inverse': '#FFFFFF',
    'border.default': '#CBD5E1',
    'border.strong': '#64748B',
    'focus.ring': '#3E5D4A',
    'status.danger': '#B91C1C',
    'status.warning': '#B45309',
    'status.success': '#15803D',
    'status.information': '#1D4ED8',
    'workflow.approval': '#6D28D9',
    'domain.finance': '#0369A1',
    'program.sah': '#0F766E',
    'program.rac': '#7E22CE',
  },
  email: {
    familyStacks: {
      display: ['Merriweather', 'Georgia', 'Times New Roman', 'serif'],
      interface: ['Space Grotesk', 'Inter', 'system-ui', 'sans-serif'],
    },
    permittedWeights: [400, 500, 600, 700],
  },
  pdf: {
    familyStacks: {
      display: ['Merriweather', 'Georgia', 'Times New Roman', 'serif'],
      interface: ['Space Grotesk', 'Inter', 'system-ui', 'sans-serif'],
    },
    permittedWeights: [400, 500, 600, 700],
  },
} as const;
